export default [
    {
        'code' : '002',
        'name' : 'กรุงเทพ (BANGKOK)',
    },
    {
        'code' : '006',
        'name' : 'กรุงไทย (KRUNG THAI)',
    },
    {
        'code' : '025',
        'name' : 'กรุงศรีอยุธยา (AYUDHAYA)',
    },
    {
        'code' : '004',
        'name' : 'กสิกรไทย (KASIKORN)',
    },
    {
        'code' : '069',
        'name' : 'เกียรตินาคิน (KIATNAKIN)',
    },
    {
        'code' : '028',
        'name' : 'คาลิยง (CALYON)',
    },
    {
        'code' : '008',
        'name' : 'เจพีมอร์แกน เชส (JPMORGAN CHASE)',
    },
    {
        'code' : '018',
        'name' : 'ชูมิโตโม มิตซุย แบงกิ้ง คอร์ปอเรชั่น (SUMITOMO MITSUI BANKING CORPORATION)',
    },
    {
        'code' : '017',
        'name' : 'ซิตี้แบงก์ (CITIBANK)',
    },
    {
        'code' : '022',
        'name' : 'ซีไอเอ็มบี ไทย (CIMB THAI)',
    },
    {
        'code' : '032',
        'name' : 'ดอยซ์แบงก์ (DEUTSCHE BANK)',
    },
    {
        'code' : '005',
        'name' : 'เดอะรอยัลแบงก์อ๊อฟสกอตแลนด์ เอ็น.วี. (THE ROYAL BANK OF SCOTLAND N.V.)',
    },
    {
        'code' : '010',
        'name' : 'โตเกียว - มิตซูบิชิ ยูเอฟเจ (TOKYO-MITSUBISHI UFJ)',
    },
    {
        'code' : '011',
        'name' : 'ทหารไทย (TMB)',
    },
    {
        'code' : '067',
        'name' : 'ทิสโก้ (TISCO)',
    },
    {
        'code' : '071',
        'name' : 'ไทยเครดิต เพื่อรายย่อย (THE THAI CREDIT RETAIL)',
    },
    {
        'code' : '014',
        'name' : 'ไทยพาณิชย์ (SIAM COMMERCIAL)',
    },
    {
        'code' : '065',
        'name' : 'ธนชาต (THANACHART)',
    },
    {
        'code' : '015',
        'name' : 'นครหลวงไทย (THE SIAM CITY)',
    },
    {
        'code' : '001',
        'name' : 'ประเทศไทย (THAILAND)',
    },
    {
        'code' : '034',
        'name' : 'เพื่อการเกษตรและสหกรณ์การเกษตร (AGRICULTURE AND AGRICULTURAL COOPERATIVES)',
    },
    {
        'code' : '039',
        'name' : 'มิซูโฮ คอร์ปอเรต (MIZUHO CORPORATE)',
    },
    {
        'code' : '026',
        'name' : 'เมกะ สากลพาณิชย์ (MEGA INTERNATIONAL COMMERCIAL)',
    },
    {
        'code' : '024',
        'name' : 'ยูโอบี (UNITED OVERSEAS)',
    },
    {
        'code' : '073',
        'name' : 'แลนด์ แอนด์ เฮ้าส์ เพื่อรายย่อย (LAND AND HOUSES RETAIL)',
    },
    {
        'code' : '020',
        'name' : 'สแตนดาร์ดชาร์เตอร์ด (ไทย) (STANDARD CHARTERED (THAI))',
    },
    {
        'code' : '070',
        'name' : 'สินเอเซีย (ACL)',
    },
    {
        'code' : '027',
        'name' : 'อเมริกาเนชั่นแนลแอสโซซิเอชั่น (AMERICA NATIONAL ASSOCIATION)',
    },
    {
        'code' : '030',
        'name' : 'ออมสิน (THE GOVERNMENT SAVINGS)',
    },
    {
        'code' : '033',
        'name' : 'อาคารสงเคราะห์ (THE GOVERNMENT HOUSING)',
    },
    {
        'code' : '066',
        'name' : 'อิสลามแห่งประเทศไทย (ISLAMIC OF THAILAND)',
    },
    {
        'code' : '031',
        'name' : 'ฮ่องกงและเซี่ยงไฮ้แบงกิ้งคอร์ปอเรชั่น (THE HONGKONG AND SHANGHAI BANKING CORPORATION)',
    },
    {
        'code': '011',
        'name': 'ธนาคารทหารไทยธนชาต จำกัด (มหาชน) (TMBTHANACHAT BANK PUBLIC COMPANY LIMITED)'
    }
]